<template>
  <div class="pa-10">
    <h1 class="mb-2">Settings</h1>
    <div style="display: grid; grid-template-columns: 200px 1fr">
      <div>
        <v-list>
          <v-list-item link @click="tab = 'calendar'">
            <v-list-item-title style="text-transform: none; font-size: 12px"
              >Calendar</v-list-item-title
            >
          </v-list-item>
          <v-list-item link @click="tab = 'openai'">
            <v-list-item-title style="text-transform: none; font-size: 12px"
              >OpenAI</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </div>

      <div v-if="tab === 'openai'" style="max-width: 700px">
        <div class="d-flex justify-end">
          <v-btn color="button" class="mb-2" @click="savePrompts">Save</v-btn>
        </div>

        <div v-if="prompts">
          <v-tabs v-model="openai_tab">
            <v-tab
              v-for="([key], i) in Object.entries(prompts)"
              :value="key"
              :key="i"
              style="text-transform: none; font-size: 12px"
              >{{ key }}</v-tab
            >
          </v-tabs>
          <v-divider class="mb-4"></v-divider>
          <div>
            <v-textarea
              rows="25"
              v-model="prompts[openai_tab]"
              :label="key"
            ></v-textarea>
          </div>
        </div>
      </div>

      <div class="calendar" v-if="tab === 'calendar'" style="max-width: 700px">
        <div class="d-flex align-center">
          <p class="mb-0">Add more days to the calendars:</p>

          <v-spacer></v-spacer>
          <v-text-field
            hide-details=""
            variant="solo"
            v-model="n"
            bg-color="smokeDark"
            flat
            density="compact"
            style="max-width: 90px; border-radius: 6px"
            type="number"
          ></v-text-field>
          <v-btn
            elevation="0"
            class="ml-2"
            dark
            color="primary"
            @click="fillCalendar"
            :loading="processing"
            ><span class="text-white"> Add </span></v-btn
          >
        </div>
        <div class="d-flex align-center mt-4">
          <p>Rank all posts across all workspaces:</p>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="ml-2"
            dark
            color="primary"
            @click="rankAllPosts"
            :loading="ranking"
            ><span class="text-white"> Rank </span></v-btn
          >
        </div>
        <div class="d-flex align-center mt-4">
          <p>Remove days from the calendars:</p>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details=""
            variant="solo"
            bg-color="smokeDark"
            v-model="n_remove"
            flat
            density="compact"
            style="max-width: 90px; border-radius: 6px"
            type="number"
          ></v-text-field>
          <v-btn
            elevation="0"
            class="ml-2"
            dark
            color="primary"
            @click="removeCalendar"
            :loading="processing"
            ><span class="text-white"> Remove </span></v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "@/firebase";
import { doc, updateDoc } from "firebase/firestore";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      calendar: (state) => state.schedules.calendar,
      prompts: (state) => state.admin.prompts,
    }),
  },
  data() {
    return {
      n: 7,
      n_remove: 7,
      open_ai_tabs: "complete",
      openai_tab: "ideas",
      processing: false,
      ranking: false,
      tab: "calendar",
    };
  },
  methods: {
    async savePrompts() {
      await updateDoc(doc(db, "admin", "prompts"), this.prompts);
      this.$store.commit("setNotification", {
        show: true,
        text: "Prompts saved",
        type: "primary",
        icon: "",
      });
    },
    async removeCalendar() {
      this.processing = true;
      const removeDays = httpsCallable(functions, "removeDays");
      await removeDays({ n: this.n_remove });
      this.processing = false;
      this.$store.commit("setNotification", {
        show: true,
        text: `Days removed from calendar!`,
        type: "primary",
        icon: "",
      });
    },
    async fixAllWorkspaces() {
      let r = confirm("Are you sure you want to fix all workspaces?");
      if (!r) return;
      const fixAllWorkspaces = httpsCallable(functions, "fixAllWorkspaces");
      let res = await fixAllWorkspaces();
      console.log(res.data);
    },
    async rankAllPosts() {
      let r = confirm("Are you sure you want to rank all posts across all workspaces?");
      if (!r) return;
      this.ranking = true;
      const rankAll = httpsCallable(functions, "rankAllPosts");
      await rankAll();
      this.ranking = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "All posts have been ranked!",
        type: "primary",
        icon: "",
      });
    },
    async fillCalendar() {
      this.processing = true;
      const extendCalendar = httpsCallable(functions, "calenderExtend");
      await extendCalendar({ n: this.n });
      this.processing = false;
      this.$store.commit("setNotification", {
        show: true,
        text: `Days added to calendar!`,
        type: "primary",
        icon: "",
      });
    },
  },
};
</script>
